// frontend_react/src/services/bankingApi.js

import api, { buildCompanyScopeHeaders } from "./api";

export const downloadSepa = ({ companyUuid } = {}) =>
  api.post(
    "/banking/sepa",
    null,
    {
      responseType: "blob",
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );

export const generateSepa = (payments = [], { companyUuid } = {}) =>
  api
    .post("/banking/sepa", payments, {
      headers: buildCompanyScopeHeaders(companyUuid),
    })
    .then((r) => r.data);

export const uploadCfonb120 = (file, { companyUuid } = {}) => {
  const data = new FormData();
  data.append("file", file);

  return api
    .post("/banking/cfonb120/upload", data, {
      headers: {
        "Content-Type": "multipart/form-data",
        ...buildCompanyScopeHeaders(companyUuid),
      },
    })
    .then((r) => r.data);
};

export const getCaTransactions = (access_token, params = {}, { companyUuid } = {}) =>
  api
    .get("/banking/credit-agricole/transactions", {
      params: { access_token, ...params },
      headers: buildCompanyScopeHeaders(companyUuid),
    })
    .then((r) => r.data);